import { RouteConfig } from 'vue-router';

const routes: Array<RouteConfig> = [
	{
		path: '',
		component: () => import('@/views/servizi-periodici/ServiziPeriodici.vue'),
		meta: {
			title: 'servizi-periodici',
			acl: 'section.serviziperiodici'
		}
	},
	{
		path: 'new',
		component: () => import('@/views/servizi-periodici/servizio-periodico/ServizioPeriodicoDetail.vue'),
		meta: {
			title: 'new-servizioperiodico',
			acl: 'section.serviziperiodici'
		}
	},
	{
		path: ':cloneid/clone',
		component: () => import('@/views/servizi-periodici/servizio-periodico/ServizioPeriodicoDetail.vue'),
		props: true,
		meta: {
			title: 'new-servizioperiodico',
			acl: 'section.serviziperiodici'
		}
	},
	{
		path: ':servizioperiodicoid/edit',
		component: () => import('@/views/servizi-periodici/servizio-periodico/ServizioPeriodicoDetail.vue'),
		props: true,
		meta: {
			title: 'edit-servizioperiodico',
			acl: 'section.serviziperiodici'
		}
	},
];

export default routes;